<section class="panel" [class.panel--centered]="centerContent">
  @if (infoFields || exportConfig) {
    <div class="panel__actions">
      <div class="panel__info">
        @for (infoField of infoFields; track idx; let idx = $index) {
          <div class="info-field">
            <span class="label">{{ infoField.fieldLabel }}:- </span>
            <span class="value">{{ (infoField.value ?? 0) | number:'1.0-0' }}</span>
          </div>
        }
      </div>
      @if (exportConfig) {
        <app-download-button [tableValues]="bars" (buttonClicked)="downloadActionOnClick()"
          exportMessage="{{ exportConfig.exportMessage }}"></app-download-button>
      }
    </div>
  }
  <div class="panel__heading" *ngIf="title || summary">
    <h3 class="panel__title" *ngIf="title">{{ title }}</h3>
    <span class="panel__summary" *ngIf="summary">{{ summary }}</span>
  </div>

  <div class="chart-list" [ngClass]="{ 'chart-list--grid': viewMode === 'grid' }" [style.--desktop-columns]="desktopColumns">
    @if (isLoading) {
      <div class="progress-skeleton">
        <app-loading-skeleton [count]="3" width="100%" height="60px" gap="5px" borderRadius="5px"></app-loading-skeleton>
      </div>
    } @else if (bars.length > 0) {
      @for (bar of bars; track bar.label) {
        <div class="chart-row" [ngClass]="{ 'chart-row--row': barLayout(bar) === 'row', 'chart-row--column': barLayout(bar) === 'column' }">
          <div class="name-wrap">
            <span class="name">{{ bar.label }}</span>
            @if (barLayout(bar) === 'row' && bar.metaCaption) {
              <span class="meta">{{ bar.metaCaption }}</span>
            }
          </div>
          <div class="bar-track" [ngClass]="'track--' + (bar.colorClass || defaultColor)">
            <div
              class="bar-fill"
              [style.width.%]="bar.pct"
              [style.transition-delay]="(bar.animDelay || 0) + 'ms'"
              [class.risk-high]="bar.pct > 60"
              [class.risk-mid]="bar.pct > 40 && bar.pct <= 60"
            ></div>
          </div>
          <div class="value-wrap">
            <span class="pct">{{ barValue(bar) }}</span>
            @if (barLayout(bar) === 'column') {
              <span class="meta">{{ barCaption(bar) }}</span>
            }
            @if (barLayout(bar) === 'row' && bar.rightCaption) {
              <span class="meta">{{ bar.rightCaption }}</span>
            }
          </div>
        </div>
      }
    } @else {
      <div class="chart-row-error">
        <span class="name">No progress data</span>
      </div>
    }
  </div>
</section>
